module.exports = __webpack_public_path__ + "img/teesThree.61606fc1.svg";